import { render, staticRenderFns } from "./BgRelationModal.vue?vue&type=template&id=b2fe02d4"
import script from "./BgRelationModal.vue?vue&type=script&lang=js"
export * from "./BgRelationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports